import api from './api';

export const industryService = {
  // Get all available industry themes
  getThemes: async () => {
    try {
      const response = await api.get('/industry/themes');
      return response.data;
    } catch (error) {
      console.error('Error fetching themes:', error);
      throw error;
    }
  },

  // Get a specific theme by service type
  getTheme: async (serviceType) => {
    try {
      const response = await api.get(`/industry/themes/${serviceType}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching theme:', error);
      throw error;
    }
  },

  // Get the theme for the currently logged-in business
  getMyTheme: async () => {
    try {
      const response = await api.get('/industry/my-theme');
      return response.data;
    } catch (error) {
      console.error('Error fetching my theme:', error);
      throw error;
    }
  },

  // Get job templates with optional filtering
  getTemplates: async (serviceType = null, commonOnly = false) => {
    try {
      const params = {};
      if (serviceType) params.serviceType = serviceType;
      if (commonOnly) params.commonOnly = true;

      const response = await api.get('/industry/templates', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  },

  // Get templates for a specific service type
  getTemplatesByServiceType: async (serviceType, commonOnly = false) => {
    try {
      const params = commonOnly ? { commonOnly: true } : {};
      const response = await api.get(`/industry/templates/${serviceType}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching templates by service type:', error);
      throw error;
    }
  },

  // Preview templates based on service selections
  previewTemplates: async (primaryServiceType, additionalServiceTypes = []) => {
    try {
      const response = await api.post('/industry/preview-templates', {
        primaryServiceType,
        additionalServiceTypes
      });
      return response.data;
    } catch (error) {
      console.error('Error previewing templates:', error);
      throw error;
    }
  },

  // Get service type summary (for dropdowns/cards)
  getServiceTypeSummary: async () => {
    try {
      const response = await api.get('/industry/service-types');
      return response.data;
    } catch (error) {
      console.error('Error fetching service type summary:', error);
      throw error;
    }
  }
};